const FORM_VIEW = {
  CREATE: 'create',
  EDIT: 'edit',
  LIST: 'list',
};

const SYSTEM_SETTING_FORM_VIEW = {
  CLAIMS: 1,
  DISPATCH: 2,
  INSIGHT: 3,
  APIKEY: 4,
};

export { FORM_VIEW, SYSTEM_SETTING_FORM_VIEW };
